$(document).ready(function() {
  ocfilter.productViewChange();
  ocfilter.initCollectionAjax();
  ocfilter.bootstrapCollectionFilters();
});

var ocfilter = {
  activeRequest: null,
  requestId: 0,
  filterState: {},
  filteredProducts: [],
  filteredPage: 1,
  filteredPerPage: 12,
  filteredRequestId: 0,
  tagResultCache: {},

  initCollectionAjax: function() {
    $(document)
      .off('click.ocfilter', '.advanced-filters a')
      .on('click.ocfilter', '.advanced-filters a', function(event) {
        event.preventDefault();
        ocfilter.toggleFilter($(this));
      })
      .off('click.ocfilterPagination', '.ajax_pagination .pagination a')
      .on('click.ocfilterPagination', '.ajax_pagination .pagination a', function(event) {
        var url = $(this).attr('href');

        if (!url || url === 'javascript:void(0);') {
          return;
        }

        event.preventDefault();

        if (ocfilter.isGroupedFilterMode() && ocfilter.hasActiveFilters()) {
          ocfilter.filteredPage = ocfilter.getPageFromUrl(url);
          ocfilter.renderFilteredProducts(true);
          return;
        }

        ocfilter.loadCollectionUrl(ocfilter.mergeCollectionParams(url), true);
      });

    $(window)
      .off('popstate.ocfilter')
      .on('popstate.ocfilter', function() {
        ocfilter.filterState = ocfilter.parseFilterStateFromUrl(window.location.href);
        ocfilter.syncFilterLinkState();

        if (ocfilter.isGroupedFilterMode()) {
          if (!ocfilter.hasActiveFilters()) {
            ocfilter.resetCollectionState(false, false);
            return;
          }

          ocfilter.applyFiltersToCurrentCollection(false);
          return;
        }

        ocfilter.loadCollectionUrl(ocfilter.buildCollectionUrl(window.location.href), {
          pushState: false
        });
      });

    $(window)
      .off('resize.ocfilterGrid')
      .on('resize.ocfilterGrid', function() {
        ocfilter.normalizeGridLayout();
      });
  },

  bootstrapCollectionFilters: function() {
    ocfilter.filterState = ocfilter.parseFilterStateFromUrl(window.location.href);
    ocfilter.decorateFilterLinks();
    ocfilter.syncFilterLinkState();

    if (ocfilter.isGroupedFilterMode()) {
      ocfilter.updateCollectionContext();

      if (ocfilter.hasActiveFilters()) {
        ocfilter.applyFiltersToCurrentCollection(false);
      }

      return;
    }

    if (ocfilter.hasActiveFilters()) {
      ocfilter.loadCollectionUrl(ocfilter.buildCollectionUrl(window.location.href), {
        pushState: false
      });
    }
  },

  toggleFilter: function($link) {
    var $holder = $link.closest('[data-filter-group]');
    var redirectUrl = $link.data('filterRedirectUrl') || $holder.data('filterRedirectUrl');
    var resetGroup = $link.data('filterResetGroup') || $holder.data('filterResetGroup');
    var group = $link.data('filter-group') || $holder.data('filter-group');
    var tag = $link.data('filterValueHandle') || $holder.data('filterValueHandle');
    var groupTags, index;

    if (redirectUrl) {
      ocfilter.filterState = ocfilter.parseFilterStateFromUrl(redirectUrl);
      ocfilter.syncFilterLinkState();
      ocfilter.loadCollectionUrl(redirectUrl, {
        pushState: true,
        closeMobileSidebar: true
      });
      return;
    }

    if (resetGroup) {
      ocfilter.resetGroupFilters(resetGroup, true, true);
      return;
    }

    if (!group || !tag) {
      return;
    }

    groupTags = ocfilter.filterState[group] || [];
    if (group === 'CATEGORIES' && tag !== 'all' && tag !== 'all-categories') {
      groupTags = $.grep(groupTags, function(existingTag) {
        return existingTag !== 'all' && existingTag !== 'all-categories';
      });
    }
    index = $.inArray(tag, groupTags);

    if (index > -1) {
      groupTags.splice(index, 1);
    } else {
      groupTags.push(tag);
    }

    if (groupTags.length) {
      ocfilter.filterState[group] = groupTags;
    } else {
      delete ocfilter.filterState[group];
    }

    ocfilter.syncFilterLinkState();

    if (ocfilter.isGroupedFilterMode()) {
      if (!ocfilter.hasActiveFilters()) {
        ocfilter.resetCollectionState(true, true);
        return;
      }

      ocfilter.applyFiltersToCurrentCollection(true, true);
      return;
    }

    ocfilter.loadCollectionUrl(ocfilter.buildCollectionUrl(window.location.href), {
      pushState: true,
      closeMobileSidebar: true
    });
  },

  hasActiveFilters: function() {
    var hasFilters = false;

    $.each(ocfilter.filterState, function(group, tags) {
      var effectiveTags = $.grep(tags || [], function(tag) {
        return !(group === 'CATEGORIES' && (tag === 'all' || tag === 'all-categories'));
      });

      if (effectiveTags.length) {
        hasFilters = true;
        return false;
      }
    });

    return hasFilters;
  },

  parseFilterStateFromUrl: function(url) {
    var state = {};
    var params = ocfilter.parseQuery((function() {
      var anchor = document.createElement('a');
      anchor.href = url;
      return anchor.search;
    })());
    var filters = params.filters;

    if (!filters) {
      return state;
    }

    filters.split('|').forEach(function(groupChunk) {
      var groupParts, groupName, tags;

      if (!groupChunk) {
        return;
      }

      groupParts = groupChunk.split(':');
      if (groupParts.length < 2) {
        return;
      }

      groupName = decodeURIComponent(groupParts.shift());
      tags = groupParts.join(':').split(',').map(function(item) {
        return decodeURIComponent(item);
      }).filter(function(item) {
        return item !== '';
      });

      if (groupName && tags.length) {
        state[groupName] = tags;
      }
    });

    return state;
  },

  serializeFilterState: function() {
    var groups = [];

    $.each(ocfilter.filterState, function(group, tags) {
      if (!tags || !tags.length) {
        return;
      }

      groups.push(
        group + ':' + $.map(tags, function(tag) {
          return tag;
        }).join(',')
      );
    });

    return groups.join('|');
  },

  buildCollectionUrl: function(url) {
    var anchor = document.createElement('a');
    var params;

    anchor.href = url || window.location.href;
    params = ocfilter.parseQuery(anchor.search);

    if (ocfilter.hasActiveFilters()) {
      params.filters = ocfilter.serializeFilterState();
      delete params.page;
    } else {
      delete params.filters;
      delete params.page;
    }

    anchor.search = ocfilter.buildQuery(params);
    return anchor.href;
  },

  mergeCollectionParams: function(url) {
    var target = document.createElement('a');
    var current = document.createElement('a');
    var targetParams, currentParams;

    target.href = url;
    current.href = window.location.href;

    targetParams = ocfilter.parseQuery(target.search);
    currentParams = ocfilter.parseQuery(current.search);

    ['sort_by', 'view', 'filters'].forEach(function(param) {
      if (!targetParams[param] && currentParams[param]) {
        targetParams[param] = currentParams[param];
      }
    });

    if (ocfilter.hasActiveFilters()) {
      targetParams.filters = ocfilter.serializeFilterState();
      delete targetParams.page;
    }

    target.search = ocfilter.buildQuery(targetParams);
    return target.href;
  },

  parseQuery: function(search) {
    var params = {};

    if (!search) {
      return params;
    }

    search.replace(/^\?/, '').split('&').forEach(function(pair) {
      var parts;

      if (!pair) {
        return;
      }

      parts = pair.split('=');
      params[decodeURIComponent(parts[0])] = decodeURIComponent((parts[1] || '').replace(/\+/g, ' '));
    });

    return params;
  },

  buildQuery: function(params) {
    var pairs = [];

    $.each(params, function(key, value) {
      if (value !== undefined && value !== null && value !== '') {
        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      }
    });

    return pairs.length ? '?' + pairs.join('&') : '';
  },

  resetCollectionState: function(pushState, closeMobileSidebar) {
    ocfilter.filterState = {};
    ocfilter.syncFilterLinkState();
    ocfilter.loadCollectionUrl(ocfilter.buildCollectionUrl(window.location.href), {
      pushState: pushState,
      closeMobileSidebar: closeMobileSidebar
    });
  },

  isAllCategoriesSelection: function() {
    var categoryTags = ocfilter.filterState.CATEGORIES || [];

    return $.inArray('all-categories', categoryTags) > -1 || $.inArray('all', categoryTags) > -1;
  },

  isGlobalAllSelection: function() {
    return window.location.pathname.indexOf('/collections/all') > -1 && ocfilter.isAllCategoriesSelection();
  },

  updateCollectionContext: function() {
    var isGlobalAllCollection = ocfilter.isGlobalAllSelection();
    var $lastBreadcrumb;

    if (!isGlobalAllCollection) {
      return;
    }

    $('.category-name').text('All Categories');

    $lastBreadcrumb = $('.breadcrumb li').last();

    if ($lastBreadcrumb.length) {
      if ($lastBreadcrumb.find('a span').length) {
        $lastBreadcrumb.find('a span').text('All Categories');
      } else if ($lastBreadcrumb.find('a').length) {
        $lastBreadcrumb.find('a').text('All Categories');
      } else {
        $lastBreadcrumb.text('All Categories');
      }
    }
  },

  resetGroupFilters: function(group, pushState, closeMobileSidebar) {
    if (!group) {
      return;
    }

    delete ocfilter.filterState[group];
    ocfilter.syncFilterLinkState();

    if (!ocfilter.hasActiveFilters()) {
      ocfilter.resetCollectionState(pushState, closeMobileSidebar);
      return;
    }

    if (ocfilter.isGroupedFilterMode()) {
      ocfilter.applyFiltersToCurrentCollection(pushState, closeMobileSidebar);
      return;
    }

    ocfilter.loadCollectionUrl(ocfilter.buildCollectionUrl(window.location.href), {
      pushState: pushState,
      closeMobileSidebar: closeMobileSidebar
    });
  },

  isGroupedFilterMode: function() {
    return $('.advanced-filters[data-filter-group]').length > 0;
  },

  applyFiltersToCurrentCollection: function(pushState, closeMobileSidebar) {
    if (ocfilter.getSelectedCategoryTags().length) {
      ocfilter.loadGroupedFilterResults(pushState, closeMobileSidebar);
      return;
    }

    ocfilter.loadCollectionUrl(ocfilter.buildCollectionUrl(window.location.href), {
      pushState: pushState,
      closeMobileSidebar: closeMobileSidebar
    });
  },

  getSelectedCategoryTags: function() {
    return $.grep(ocfilter.filterState.CATEGORIES || [], function(tag) {
      return tag && tag !== 'all' && tag !== 'all-categories';
    });
  },

  getSelectedCategoryTagHandles: function() {
    return $.map(ocfilter.getSelectedCategoryTags(), function(selectedTag) {
      var tagHandle = selectedTag;

      $('.advanced-filters[data-filter-group="CATEGORIES"] [data-filter-value-handle]').each(function() {
        var $holder = $(this);

        if ($holder.data('filterValueHandle') === selectedTag) {
          tagHandle = $holder.data('filterTagHandle') || selectedTag;
          return false;
        }
      });

      return tagHandle;
    });
  },

  getCollectionRootPath: function() {
    var path = window.location.pathname.replace(/\/+$/, '');
    var matches = path.match(/^\/collections\/([^\/]+)/);

    if (!matches) {
      return '/collections/all';
    }

    return '/collections/' + matches[1];
  },

  getPageFromUrl: function(url) {
    var anchor = document.createElement('a');
    var params;
    var page;

    anchor.href = url || window.location.href;
    params = ocfilter.parseQuery(anchor.search);
    page = parseInt(params.page, 10);

    return page > 0 ? page : 1;
  },

  getFilteredStateUrl: function(page) {
    var anchor = document.createElement('a');
    var current = document.createElement('a');
    var params;

    current.href = window.location.href;
    anchor.href = ocfilter.getCollectionRootPath();
    params = ocfilter.parseQuery(current.search);

    if (ocfilter.hasActiveFilters()) {
      params.filters = ocfilter.serializeFilterState();
    } else {
      delete params.filters;
    }

    if (page && page > 1) {
      params.page = page;
    } else {
      delete params.page;
    }

    anchor.search = ocfilter.buildQuery(params);
    return anchor.href;
  },

  getTagResultUrl: function(tagHandle, page, fetchAll) {
    var anchor = document.createElement('a');
    var current = document.createElement('a');
    var currentParams;
    var params = {};

    current.href = window.location.href;
    currentParams = ocfilter.parseQuery(current.search);

    ['sort_by', 'view'].forEach(function(param) {
      if (currentParams[param]) {
        params[param] = currentParams[param];
      }
    });

    if (fetchAll) {
      params.view = 'all';
      delete params.page;
    } else if (page && page > 1) {
      params.page = page;
    }

    anchor.href = ocfilter.getCollectionRootPath() + '/' + encodeURIComponent(tagHandle);
    anchor.search = ocfilter.buildQuery(params);
    return anchor.href;
  },

  loadGroupedFilterResults: function(pushState, closeMobileSidebar) {
    var selectedTags = ocfilter.getSelectedCategoryTags();
    var selectedTagHandles = ocfilter.getSelectedCategoryTagHandles();
    var currentRequestId = ++ocfilter.filteredRequestId;
    var requests = [];
    var productKeys = {};
    var filteredProducts = [];

    if (!selectedTags.length) {
      ocfilter.resetCollectionState(pushState, closeMobileSidebar);
      return;
    }

    ocfilter.filteredPage = pushState ? 1 : ocfilter.getPageFromUrl(window.location.href);
    ocfilter.filteredPerPage = ocfilter.getProductsPerPage();

    $("#wraper_ajax").show();
    $('.layered-navigation-block').show();

    $.each(selectedTagHandles, function(_, tagHandle) {
      requests.push(ocfilter.fetchTagResultPages(tagHandle));
    });

    $.when.apply($, requests)
      .done(function() {
        if (currentRequestId !== ocfilter.filteredRequestId) {
          return;
        }

        $.each(arguments, function(_, resultSet) {
          $.each(resultSet || [], function(__, product) {
            if (!productKeys[product.key]) {
              productKeys[product.key] = true;
              filteredProducts.push(product.html);
            }
          });
        });

        ocfilter.filteredProducts = filteredProducts;
        ocfilter.renderFilteredProducts(pushState);

        if (closeMobileSidebar) {
          ocfilter.closeMobileSidebar();
        }
      })
      .always(function() {
        if (currentRequestId === ocfilter.filteredRequestId) {
          $("#wraper_ajax").hide();
          $('.layered-navigation-block').hide();
        }
      });
  },

  fetchTagResultPages: function(tagHandle) {
    var products = [];
    var deferred = $.Deferred();
    var seenUrls = {};
    var cacheKey = ocfilter.getTagResultCacheKey(tagHandle);

    if (ocfilter.tagResultCache[cacheKey]) {
      deferred.resolve(ocfilter.tagResultCache[cacheKey]);
      return deferred.promise();
    }

    function fetchPage(url) {
      if (seenUrls[url]) {
        ocfilter.tagResultCache[cacheKey] = products;
        deferred.resolve(products);
        return;
      }

      seenUrls[url] = true;

      $.ajax({
        type: 'GET',
        url: url,
        dataType: 'html',
        success: function(responseText) {
          var $response = $('<div>').append($.parseHTML(responseText));
          var nextUrl = $response.find('#pagination .pagination-next a').attr('href');

          $response.find('#custom-products .product-layout').each(function() {
            var $product = $(this);
            var key = $product.find('.product-name a').attr('href') || $product.find('a[href*="/products/"]').first().attr('href') || $product.text();

            products.push({
              key: key,
              html: $('<div>').append($product.clone()).html()
            });
          });

          if (nextUrl) {
            fetchPage(ocfilter.mergeTagResultPageUrl(nextUrl, true));
          } else {
            ocfilter.tagResultCache[cacheKey] = products;
            deferred.resolve(products);
          }
        },
        error: function() {
          deferred.resolve(products);
        }
      });
    }

    fetchPage(ocfilter.getTagResultUrl(tagHandle, 1, true));
    return deferred.promise();
  },

  getTagResultCacheKey: function(tagHandle) {
    var params = ocfilter.parseQuery(window.location.search);
    return [
      ocfilter.getCollectionRootPath(),
      tagHandle,
      params.sort_by || ''
    ].join('|');
  },

  mergeTagResultPageUrl: function(url, fetchAll) {
    var target = document.createElement('a');
    var current = document.createElement('a');
    var targetParams;
    var currentParams;

    target.href = url;
    current.href = window.location.href;
    targetParams = ocfilter.parseQuery(target.search);
    currentParams = ocfilter.parseQuery(current.search);

    ['sort_by', 'view'].forEach(function(param) {
      if (!targetParams[param] && currentParams[param]) {
        targetParams[param] = currentParams[param];
      }
    });

    if (fetchAll) {
      targetParams.view = 'all';
    }

    delete targetParams.filters;
    target.search = ocfilter.buildQuery(targetParams);
    return target.href;
  },

  getProductsPerPage: function() {
    var viewSize = ocfilter.getViewPageSize();
    var amountText = $('#collection-amount').text();
    var amountMatch = amountText.match(/\bto\s+(\d+)\s+of\b/i);
    var productCount = $('#custom-products .product-layout').length;
    var perPage;

    if (viewSize) {
      return viewSize;
    }

    if (amountMatch) {
      perPage = parseInt(amountMatch[1], 10);
      if (perPage > 0) {
        return perPage;
      }
    }

    return productCount > 0 ? productCount : 12;
  },

  getViewPageSize: function() {
    var params = ocfilter.parseQuery(window.location.search);
    var view = params.view || $('#input-limit').val() || $('#input-limit option:selected').text();
    var size;

    view = String(view || '').toLowerCase();

    if (view === 'all' || view.indexOf('all') > -1) {
      return 999999;
    }

    size = parseInt(view.replace(/[^0-9]/g, ''), 10);
    return size > 0 ? size : null;
  },

  renderFilteredProducts: function(pushState) {
    var total = ocfilter.filteredProducts.length;
    var totalPages = Math.max(1, Math.ceil(total / ocfilter.filteredPerPage));
    var start;
    var end;
    var pageProducts;
    var url;

    if (ocfilter.filteredPage > totalPages) {
      ocfilter.filteredPage = totalPages;
    }

    start = (ocfilter.filteredPage - 1) * ocfilter.filteredPerPage;
    end = Math.min(start + ocfilter.filteredPerPage, total);
    pageProducts = ocfilter.filteredProducts.slice(start, end);

    if (pageProducts.length) {
      $('#custom-products').html(pageProducts.join(''));
    } else {
      $('#custom-products').html('<div class="grid-item"><p>No products match your selected filters</p></div>');
    }

    ocfilter.updateFilteredCollectionAmount(total, start, end);
    ocfilter.renderFilteredPagination(totalPages);
    ocfilter.productViewChange();
    ocfilter.syncFilterLinkState();
    ocfilter.normalizeGridLayout();

    url = ocfilter.getFilteredStateUrl(ocfilter.filteredPage);
    if (pushState) {
      history.pushState({ page: url }, '', url);
    }
  },

  updateFilteredCollectionAmount: function(total, start, end) {
    var text;

    if (!total) {
      text = 'No products match your selected filters';
    } else if (total === 1) {
      text = 'Showing 1 to 1 of 1 item';
    } else {
      text = 'Showing ' + (start + 1) + ' to ' + end + ' of ' + total + ' items';
    }

    $('#collection-amount').text(text);
    $('#pagination .toolbar-amount span').text(text);
  },

  renderFilteredPagination: function(totalPages) {
    var html = '';
    var page;

    if (totalPages > 1) {
      html += '<ul class="pagination">';

      if (ocfilter.filteredPage > 1) {
        html += '<li><a href="' + ocfilter.getFilteredStateUrl(ocfilter.filteredPage - 1) + '" title="Previous">&lt;</a></li>';
      }

      for (page = 1; page <= totalPages; page++) {
        if (page === ocfilter.filteredPage) {
          html += '<li class="active"><span>' + page + '</span></li>';
        } else {
          html += '<li><a href="' + ocfilter.getFilteredStateUrl(page) + '" title="">' + page + '</a></li>';
        }
      }

      if (ocfilter.filteredPage < totalPages) {
        html += '<li class="pagination-next"><a href="' + ocfilter.getFilteredStateUrl(ocfilter.filteredPage + 1) + '" title="Next">&gt;</a></li>';
      }

      html += '</ul>';
    }

    $('#pagination').show();
    $('#pagination .pages').html(html);
  },

  closeMobileSidebar: function() {
    if ($(window).width() > 991) {
      return;
    }

    $('.sidebar-overlay').hide();
    $('#column-left').hide();
  },

  loadCollectionUrl: function(url, options) {
    var currentRequestId = ++ocfilter.requestId;
    var settings = $.extend({
      pushState: false,
      closeMobileSidebar: false
    }, typeof options === 'object' ? options : {
      pushState: !!options
    });

    if (ocfilter.activeRequest && ocfilter.activeRequest.readyState !== 4) {
      ocfilter.activeRequest.abort();
    }

    ocfilter.activeRequest = $.ajax({
      type: 'GET',
      url: url,
      dataType: 'html',
      beforeSend: function() {
        $("#wraper_ajax").show();
        $('.layered-navigation-block').show();
      },
      success: function(responseText) {
        if (currentRequestId !== ocfilter.requestId) {
          return;
        }

        var $response = $('<div>').append($.parseHTML(responseText));
        ocfilter.replaceCollectionPart('#custom-products', $response);
        ocfilter.replaceCollectionPart('#column-left', $response);
        ocfilter.replaceCollectionPart('#collection-amount', $response);
        ocfilter.replaceCollectionPart('#pagination', $response);
        ocfilter.replaceCollectionPart('.category-name', $response);
        ocfilter.replaceCollectionPart('.category-des', $response);
        ocfilter.replaceCollectionPart('.breadcrumb', $response);

        ocfilter.decorateFilterLinks();
        ocfilter.productViewChange();
        ocfilter.syncFilterLinkState();

        if (ocfilter.isGlobalAllSelection()) {
          $('#custom-products .product-layout[data-product-tags]').show();
          ocfilter.updatePaginationVisibility();
          ocfilter.normalizeGridLayout();
        } else if (ocfilter.hasActiveFilters()) {
          ocfilter.applyProductFilters();
        } else {
          $('#custom-products .product-layout[data-product-tags]').show();
          ocfilter.updatePaginationVisibility();
          ocfilter.normalizeGridLayout();
        }

        ocfilter.updateCollectionContext();

        if (settings.pushState) {
          history.pushState({ page: url }, '', url);
        }

        if (settings.closeMobileSidebar) {
          ocfilter.closeMobileSidebar();
        }

        if (window.Wishlist && typeof Wishlist.init === 'function') {
          Wishlist.init();
        }

        if (window.SPR) {
          SPR.registerCallbacks();
          SPR.initRatingHandler();
          SPR.initDomEls();
          SPR.loadProducts();
          SPR.loadBadges();
        }
      },
      complete: function() {
        if (currentRequestId === ocfilter.requestId) {
          $("#wraper_ajax").hide();
          $('.layered-navigation-block').hide();
        }
      }
    });
  },

  replaceCollectionPart: function(selector, $response) {
    var $replacement = $response.find(selector);

    if ($replacement.length) {
      $(selector).html($replacement.html());
    }
  },

  decorateFilterLinks: function() {
    $('.filter-attribute-container').find('a').addClass('advanced-filter a-filter add-filter');
  },

  syncFilterLinkState: function() {
    $('.advanced-filters [data-filter-group]').each(function() {
      var $holder = $(this);
      var $link = $holder.find('a').first();
      var redirectUrl = $link.data('filterRedirectUrl') || $holder.data('filterRedirectUrl');
      var collectionUrl = $link.data('filterCollectionUrl') || $holder.data('filterCollectionUrl');
      var resetGroup = $holder.data('filterResetGroup');
      var group = $holder.data('filter-group');
      var tag = $holder.data('filterValueHandle');
      var tagHandle = $holder.data('filterTagHandle');
      var selected;

      if (redirectUrl) {
        selected = false;
      } else if (group === 'CATEGORIES' && tag) {
        selected = ocfilter.isTagSelected(group, tag) || (!ocfilter.hasActiveFilters() && collectionUrl && tagHandle && ocfilter.isCurrentTagHandleInPath(tagHandle));
      } else if (resetGroup) {
        selected = !((ocfilter.filterState[resetGroup] || []).length);
      } else {
        selected = group && tag && ocfilter.isTagSelected(group, tag);
      }

      $holder.toggleClass('active-filter', !!selected);
      $link.toggleClass('active', !!selected);
    });
  },

  isTagSelected: function(group, tag) {
    var tags = ocfilter.filterState[group] || [];
    return $.inArray(tag, tags) > -1;
  },

  isCurrentTagHandleInPath: function(tagHandle) {
    var path = window.location.pathname.replace(/\/+$/, '');
    return !!tagHandle && path.indexOf('/' + tagHandle) > -1;
  },

  handleizeValue: function(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  },

  buildProductFilterMap: function(tags) {
    var grouped = {};

    $.each(tags, function(_, tag) {
      var parts = String(tag || '').split('_');
      var group = parts.shift();
      var value = parts.join('_');
      var valueHandle;

      if (!group || !value) {
        return;
      }

      valueHandle = ocfilter.handleizeValue(value);

      if (!grouped[group]) {
        grouped[group] = [];
      }

      if ($.inArray(valueHandle, grouped[group]) === -1) {
        grouped[group].push(valueHandle);
      }
    });

    return grouped;
  },

  matchesFilters: function(productFilterMap) {
    var matched = true;

    $.each(ocfilter.filterState, function(group, selectedTags) {
      var groupMatched = false;
      var productGroupTags = productFilterMap[group] || [];

      $.each(selectedTags, function(_, selectedTag) {
        if ($.inArray(selectedTag, productGroupTags) > -1) {
          groupMatched = true;
          return false;
        }
      });

      if (!groupMatched) {
        matched = false;
        return false;
      }
    });

    return matched;
  },

  applyProductFilters: function() {
    var $items = $('#custom-products .product-layout[data-product-tags]');
    var visibleCount = 0;

    if (!$items.length) {
      return;
    }

    if (!ocfilter.hasActiveFilters()) {
      $items.show();
      ocfilter.normalizeGridLayout();
      return;
    }

    $items.each(function() {
      var $item = $(this);
      var tags = $item.attr('data-product-tags');
      var productFilterMap;

      try {
        tags = tags ? JSON.parse(tags) : [];
      } catch (e) {
        tags = [];
      }

      productFilterMap = ocfilter.buildProductFilterMap(tags);

      if (ocfilter.matchesFilters(productFilterMap)) {
        $item.show();
        visibleCount++;
      } else {
        $item.hide();
      }
    });

    ocfilter.updateCollectionAmount(visibleCount);
    ocfilter.normalizeGridLayout();
  },

  updateCollectionAmount: function(visibleCount) {
    var text;

    if (visibleCount === 0) {
      text = 'No products match your selected filters';
    } else if (visibleCount === 1) {
      text = 'Showing 1 to 1 of 1 item';
    } else {
      text = 'Showing 1 to ' + visibleCount + ' of ' + visibleCount + ' items';
    }

    $('#collection-amount').text(text);
  },

  updatePaginationVisibility: function() {
    $('#pagination').toggle(!ocfilter.hasActiveFilters() || ocfilter.isGlobalAllSelection());
  },

  getItemsPerRow: function($item) {
    var width = $(window).width();
    var className = $item.attr('class') || '';

    if (className.indexOf('product-list') > -1) {
      return 1;
    }

    if (width >= 1200) {
      if (className.indexOf('col-lg-divide-5') > -1) { return 5; }
      if (className.indexOf('col-lg-2') > -1) { return 6; }
      if (className.indexOf('col-lg-3') > -1) { return 4; }
      if (className.indexOf('col-lg-4') > -1) { return 3; }
      if (className.indexOf('col-lg-6') > -1) { return 2; }
    }

    if (width >= 992) {
      if (className.indexOf('col-md-2') > -1) { return 6; }
      if (className.indexOf('col-md-3') > -1) { return 4; }
      if (className.indexOf('col-md-4') > -1) { return 3; }
      if (className.indexOf('col-md-6') > -1) { return 2; }
    }

    if (width >= 768) {
      if (className.indexOf('col-sm-2') > -1) { return 6; }
      if (className.indexOf('col-sm-3') > -1) { return 4; }
      if (className.indexOf('col-sm-4') > -1) { return 3; }
      if (className.indexOf('col-sm-6') > -1) { return 2; }
    }

    if (width >= 480) {
      if (className.indexOf('col-xs-4') > -1) { return 3; }
      if (className.indexOf('col-xs-6') > -1) { return 2; }
    }

    return 1;
  },

  normalizeGridLayout: function() {
    var $items = $('#custom-products .product-layout.product-item');
    var $visibleItems = $items.filter(':visible');
    var itemsPerRow;

    if (!$visibleItems.length) {
      return;
    }

    itemsPerRow = ocfilter.getItemsPerRow($visibleItems.first());

    $items.css('clear', 'none');

    if (itemsPerRow <= 1) {
      $visibleItems.css('clear', 'none');
      return;
    }

    $visibleItems.each(function(index) {
      $(this).css('clear', index % itemsPerRow === 0 ? 'left' : 'none');
    });
  },

  /* Filter action */
  'filter' : function(filter_url) {
    $.ajax({
      url         : filter_url,
      type        : 'get',
      beforeSend  : function () {
        $('.layered-navigation-block').show();
        $('.ajax-loader').show();
      },
      success     : function(json) {
        $('.filter-url').val(json['filter_action']);
        $('.price-url').val(json['price_action']);
        $('.custom-category').html(json['result_html']);
        $('.layered').html(json['layered_html']);
        ocfilter.paginationChangeAction();
        ocfilter.productViewChange();
        $('.layered-navigation-block').hide();
        $('.ajax-loader').hide();
        $("html, body").animate({ scrollTop: 0 }, "slow");
      }
    });

  },

  /* Use again and update ajaxComplete from common.js */
  'productViewChange' : function() {
    // Product List
    $('#list-view').off('click.ocfilterView').on('click.ocfilterView', function() {
      $('#content .product-grid > .clearfix').remove();

      $('#content .row > .product-grid').attr('class', 'product-layout product-list col-xs-12 product-item');
      $('#grid-view').removeClass('active');
      $('#list-view').addClass('active');

      localStorage.setItem('display', 'list');
      localStorage.setItem('type', 'none');
      ocfilter.normalizeGridLayout();
    });

    // Product Grid
    $('#grid-view').off('click.ocfilterView').on('click.ocfilterView', function() {
      var cols = $('#column-right, #column-left').length;

      if (cols == 2) {
        $('#content .product-list').attr('class', 'product-layout product-grid grid-style col-lg-6 col-md-6 col-sm-6 col-xs-6 product-item');
      } else if (cols == 1) {
        $('#content .product-list').attr('class', 'product-layout product-grid grid-style col-lg-4 col-md-4 col-sm-6 col-xs-6 product-item');
      } else {
        $('#content .product-list').attr('class', 'product-layout product-grid grid-style col-lg-3 col-md-3 col-sm-6 col-xs-6 product-item');
      }

      $('#list-view').removeClass('active');
      $('#grid-view').addClass('active');

      localStorage.setItem('display', 'grid');
      localStorage.setItem('type', 'none');
      ocfilter.normalizeGridLayout();
    });

    if (localStorage.getItem('display') == 'list') {
      $('#list-view').trigger('click');
      $('#list-view').addClass('active');
    } else {
      $('#grid-view').trigger('click');
      $('#grid-view').addClass('active');
    }

    // Custom Grid
    if(localStorage.getItem('type') == null) {
      var type = $('#category-view-type').val();
      var cols = $('#category-grid-cols').val();

      if(type == "list") {
        category_view.initView(type, cols, 'btn-list');
      }

      if(type == 'grid') {
        category_view.initView(type, cols, 'btn-grid-' + cols);
      }
    } else {
      var type = localStorage.getItem('type');
      var cols = localStorage.getItem('cols');
      var element = localStorage.getItem('element');

      if(type != 'none') {
        category_view.initView(type, cols, element);
      }
    }
  },

  /* Modify pagination links */
  paginationChangeAction: function () {
    $('.ajax_pagination .pagination a').each(function () {
      var href = $(this).attr('href');
      $(this).attr('onclick', 'ocfilter.filter("'+ href +'")');
      $(this).attr('href', 'javascript:void(0);');
    });
  }

};
